import { useEffect, useState } from 'react';
import WrapperContent from '@components/Layout/WrapperContent';
import useScriptFlag from '@/hooks/useScriptFlag';
import Script from 'next/script';
import { useRouter } from 'next/router';

export interface AdMgidProps {
  type: 'mobile' | 'desktop';
}

export default function AdMgid({ type }: AdMgidProps) {
  const variants = {
    mobile: 'desktop:hidden flex',
    desktop: 'desktop:flex hidden',
  } as const;
  const router = useRouter();
  const shouldRenderAds = useScriptFlag({ adFlag: 'mgid' });

  const [shouldRender, setShouldRender] = useState(false);

  const mgIdScript = type === 'mobile' ? '1536993' : '1525795';
  const scriptTimer = !Number.isNaN(Number(router.query?.timer)) ? Number(router.query?.timer) : 5000;

  const appendScript = () => {
    setTimeout(() => {
      setShouldRender(true);
    }, scriptTimer);
  };

  useEffect(() => {
    if (shouldRenderAds) appendScript();
  }, []);

  return (
    <WrapperContent mobileOnly={type === 'mobile'} desktopOnly={type === 'desktop'} className="desktop:mb-[90px]">
      <div className={variants[type]} id={`mgidContainerCT${type}`}>
        <div data-type="_mgwidget" data-widget-id={mgIdScript} />
        <Script>
          <>
            {shouldRender &&
              (function (w, q) {
                w[q] = w[q] || [];
                w[q].push(['_mgc.load']);
              })(window, '_mgq')}
          </>
        </Script>
      </div>
    </WrapperContent>
  );
}
